class EventBus {
  constructor() {
    if (EventBus.instance) {
      return EventBus.instance;
    }
    this.listeners = new Map();
    EventBus.instance = this;
  }

  on(event, callback, context = null) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }

    this.listeners.get(event).push({ callback, context });
  }

  emit(event, data = {}) {
    if (!this.listeners.has(event)) return;

    const listeners = this.listeners.get(event);
    
    listeners.forEach(({ callback, context }) => {
      try {
        callback.call(context, data);
      } catch (error) {
        console.error(`EventBus error for event "${event}":`, error);
      }
    });
  }

  off(event, callback, context = null) {
    if (!this.listeners.has(event)) return;

    const listeners = this.listeners.get(event);
    const index = listeners.findIndex(
      l => l.callback === callback && l.context === context
    );

    if (index > -1) {
      listeners.splice(index, 1);
      
      if (listeners.length === 0) {
        this.listeners.delete(event);
      }
    }
  }
}

const eventBus = new EventBus();
export default eventBus;